export default __webpack_public_path__ + "static/VW Passat B4-37ef50b0f4aeb34b8737efe995ebcd8a.jpg";